// import React, { useState, useEffect } from "react";
// import NuovaOrchestra from "../imgs/Nuova orchestra.jpeg";
// import {
//   FaUsers,
//   FaBullseye,
//   FaLightbulb,
//   FaMusic,
//   FaChevronLeft,
//   FaChevronRight,
//   FaSearchPlus,
//   FaGift,
// } from "react-icons/fa";
// import { useForm } from "@formspree/react";
// import loc5x1000 from "../imgs/Locandine/Locandina5x1000.jpeg";

// const importAll = (r) => r.keys().map(r);

// const galleryImages = importAll(
//   require.context("../imgs/Galleria", false, /\.(png|jpe?g|webp)$/),
// );

// const shuffle = (list) => {
//   const copy = [...list];
//   for (let i = copy.length - 1; i > 0; i--) {
//     const j = Math.floor(Math.random() * (i + 1));
//     [copy[i], copy[j]] = [copy[j], copy[i]];
//   }
//   return copy;
// };

// /* ------------------------------------------------------------------ */
// /*  Gallery                                                            */
// /*  - dissolvenza incrociata tra le foto (nessun "buco" bianco)        */
// /*  - sfondo sfocato della foto stessa, così qualsiasi formato riempie */
// /*  - frecce, contatore, pausa al passaggio del mouse                  */
// /* ------------------------------------------------------------------ */
// const Gallery = ({ images, onOpen }) => {
//   const [index, setIndex] = useState(0);
//   const [paused, setPaused] = useState(false);
//   const total = images.length;

//   useEffect(() => {
//     if (paused || total <= 1) return;
//     const id = setInterval(() => setIndex((i) => (i + 1) % total), 5000);
//     return () => clearInterval(id);
//   }, [paused, total, index]);

//   if (total === 0) return null;

//   const prev = () => setIndex((i) => (i - 1 + total) % total);
//   const next = () => setIndex((i) => (i + 1) % total);

//   return (
//     <div
//       className="relative w-11/12 md:w-3/4 lg:w-2/3 h-80 md:h-[28rem] rounded-3xl overflow-hidden shadow-xl bg-amber-100"
//       onMouseEnter={() => setPaused(true)}
//       onMouseLeave={() => setPaused(false)}
//     >
//       {images.map((src, i) => {
//         // Monta solo la foto corrente, la precedente e la successiva
//         const dist = (i - index + total) % total;
//         if (dist > 1 && dist !== total - 1) return null;
//         const active = i === index;

//         return (
//           <div
//             key={i}
//             className={`absolute inset-0 transition-opacity duration-1000 motion-reduce:transition-none ${
//               active ? "opacity-100" : "opacity-0 pointer-events-none"
//             }`}
//           >
//             <img
//               src={src}
//               alt=""
//               aria-hidden="true"
//               className="absolute inset-0 w-full h-full object-cover scale-110 blur-2xl opacity-60"
//             />
//             <img
//               src={src}
//               alt={active ? "Foto dalla galleria di MilArte" : ""}
//               onClick={() => onOpen(src)}
//               className="relative w-full h-full object-contain cursor-zoom-in"
//             />
//           </div>
//         );
//       })}

//       {total > 1 && (
//         <>
//           <button
//             type="button"
//             onClick={prev}
//             aria-label="Foto precedente"
//             className="absolute left-3 top-1/2 -translate-y-1/2 z-10 flex items-center justify-center w-10 h-10 rounded-full bg-black/50 text-white hover:bg-red-600 transition-colors focus:outline-none focus-visible:ring-4 focus-visible:ring-red-400"
//           >
//             <FaChevronLeft />
//           </button>
//           <button
//             type="button"
//             onClick={next}
//             aria-label="Foto successiva"
//             className="absolute right-3 top-1/2 -translate-y-1/2 z-10 flex items-center justify-center w-10 h-10 rounded-full bg-black/50 text-white hover:bg-red-600 transition-colors focus:outline-none focus-visible:ring-4 focus-visible:ring-red-400"
//           >
//             <FaChevronRight />
//           </button>
//           <span className="absolute bottom-3 right-3 z-10 bg-black/60 text-white text-xs font-semibold px-3 py-1 rounded-full">
//             {index + 1} / {total}
//           </span>
//         </>
//       )}
//     </div>
//   );
// };

// /* ------------------------------------------------------------------ */
// /*  Home                                                               */
// /* ------------------------------------------------------------------ */
// const chiSiamo = [
//   {
//     icon: <FaUsers />,
//     color: "text-red-600 bg-red-50",
//     titolo: "Chi siamo",
//     testo: (
//       <>
//         MilArte è un'Associazione di Promozione Sociale dedicata alla musica,
//         fondata nel 2023 con l'obiettivo di diffondere la passione musicale e
//         creare un impatto positivo nella comunità. La visione di{" "}
//         <a
//           href="https://www.giuseppedinardo.it/"
//           className="text-red-600 font-semibold hover:underline"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Giuseppe Dinardo
//         </a>{" "}
//         ha guidato la nascita dell’associazione, consolidando la sua presenza
//         nel panorama musicale milanese.
//       </>
//     ),
//   },
//   {
//     icon: <FaBullseye />,
//     color: "text-amber-700 bg-amber-100",
//     titolo: "I nostri obiettivi",
//     testo: (
//       <>
//         Gli obiettivi principali includono la proposta di concerti, eventi e
//         iniziative culturali per rendere la musica accessibile e viva. MilArte
//         lavora per creare esperienze musicali che arricchiscano la vita di chi
//         ascolta e di chi suona.
//       </>
//     ),
//   },
//   {
//     icon: <FaLightbulb />,
//     color: "text-yellow-600 bg-yellow-50",
//     titolo: "Nelle scuole",
//     testo: (
//       <>
//         In programma anche visite e concerti nelle scuole per condividere la
//         magia della musica fatta con mani umane e nutrire interiormente i
//         giovani ascoltatori.
//       </>
//     ),
//   },
// ];

// const Home = () => {
//   const [images] = useState(() => shuffle(galleryImages));
//   const [fullScreenImage, setFullScreenImage] = useState(null);
//   const [state, handleSubmit] = useForm("xpwkaddj");

//   const handleImageClick = (img) => setFullScreenImage(img);
//   const closeImage = () => setFullScreenImage(null);

//   // Chiude l'immagine a schermo intero con il tasto Esc
//   useEffect(() => {
//     if (!fullScreenImage) return;
//     const onKey = (e) => {
//       if (e.key === "Escape") setFullScreenImage(null);
//     };
//     document.addEventListener("keydown", onKey);
//     return () => document.removeEventListener("keydown", onKey);
//   }, [fullScreenImage]);

//   return (
//     <div className="flex flex-col items-center bg-gradient-to-r from-white to-amber-50 min-h-screen text-gray-800 overflow-hidden">
//       <FaMusic className="fixed text-amber-200/40 text-[180px] rotate-12 -top-5 -right-5 z-0" />

//       {/* --- INTESTAZIONE --- */}
//       <header className="relative z-10 flex flex-col md:flex-row items-center justify-center gap-6 md:gap-10 w-11/12 md:w-3/4 lg:w-2/3 mt-10 mb-8 text-center md:text-left">
//         <img
//           src={NuovaOrchestra}
//           alt="Logo Nuova Orchestra"
//           className="w-28 md:w-36 rounded-2xl shadow-lg"
//         />
//         <div>
//           <h1 className="text-red-600 font-extrabold text-5xl md:text-6xl tracking-wide">
//             MilArte
//           </h1>
//           <p className="mt-2 text-xl md:text-2xl text-amber-900 font-medium">
//             La Bellezza del far musica
//           </p>
//           <div className="mt-5 flex flex-wrap justify-center md:justify-start gap-3">
//             <a
//               href="#chi-siamo"
//               className="bg-red-600 text-white px-5 py-2 rounded-lg font-semibold text-base hover:bg-red-700 transition"
//             >
//               Scopri chi siamo
//             </a>
//             <a
//               href="#newsletter"
//               className="border-2 border-red-600 text-red-600 px-5 py-2 rounded-lg font-semibold text-base hover:bg-red-50 transition"
//             >
//               Iscriviti alla newsletter
//             </a>
//           </div>
//         </div>
//       </header>

//       {/* --- GALLERIA --- */}
//       <div className="relative z-10 w-full flex justify-center mb-16">
//         <Gallery images={images} onOpen={handleImageClick} />
//       </div>

//       {/* --- CHI SIAMO --- */}
//       <section
//         id="chi-siamo"
//         className="relative z-10 w-11/12 md:w-3/4 lg:w-2/3 mb-16"
//       >
//         <h2 className="text-3xl font-bold text-red-600 mb-8 text-center md:text-left">
//           Una associazione che fa musica insieme
//         </h2>
//         <div className="flex flex-col gap-8">
//           {chiSiamo.map((voce) => (
//             <div key={voce.titolo} className="flex items-start gap-5">
//               <span
//                 className={`shrink-0 flex items-center justify-center w-14 h-14 rounded-full text-2xl ${voce.color}`}
//               >
//                 {voce.icon}
//               </span>
//               <div>
//                 <h3 className="text-xl font-semibold text-gray-900">
//                   {voce.titolo}
//                 </h3>
//                 <p className="mt-1 text-lg leading-relaxed text-gray-700">
//                   {voce.testo}
//                 </p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* --- CITAZIONE --- */}
//       <section className="relative z-10 w-full bg-red-700 text-white py-16 px-6 mb-16">
//         <figure className="max-w-3xl mx-auto text-center">
//           <h2 className="text-xl md:text-2xl font-bold text-amber-200 mb-6">
//             Nuova Milano
//           </h2>
//           <blockquote className="font-serif italic text-xl md:text-3xl leading-relaxed">
//             “Una scatola sono di cerini, i musicisti mentre stanno insieme,
//             pronti a incendiarsi per spiccare il volo. Saranno un palloncino
//             della fiera come quelli sfuggiti dalle mani che sembrano uno stormo
//             cittadino o un labirinto in note musicali che anche a una carriola
//             dà le ali.”
//           </blockquote>
//           <figcaption className="mt-6 text-base md:text-lg font-semibold text-amber-100">
//             Guido Oldani, ideatore del Realismo Terminale (inedito)
//           </figcaption>
//         </figure>
//       </section>

//       {/* --- 5x1000 --- */}
//       <section className="relative z-10 w-11/12 md:w-3/4 lg:w-2/3 mb-16 flex flex-col md:flex-row items-center gap-8 bg-white/60 backdrop-blur-md rounded-3xl shadow-md border border-amber-100 p-6 md:p-10">
//         <button
//           type="button"
//           onClick={() => handleImageClick(loc5x1000)}
//           aria-label="Ingrandisci la locandina del 5x1000"
//           className="relative w-2/3 sm:w-1/2 md:w-2/5 shrink-0 rounded-2xl overflow-hidden shadow-lg cursor-pointer group focus:outline-none focus-visible:ring-4 focus-visible:ring-red-400"
//         >
//           <img
//             src={loc5x1000}
//             alt="Locandina 5x1000"
//             className="w-full group-hover:scale-105 transition-transform duration-700"
//           />
//           <span className="absolute bottom-3 right-3 flex items-center justify-center w-10 h-10 rounded-full bg-black/70 text-white text-sm group-hover:bg-red-600 transition-colors duration-300">
//             <FaSearchPlus />
//           </span>
//         </button>
//         <div className="text-center md:text-left">
//           <h2 className="text-2xl md:text-3xl font-bold text-red-600">
//             Sostieni MilArte
//           </h2>
//           <p className="mt-3 text-lg text-gray-700 leading-relaxed">
//             Tocca la locandina per ingrandirla e scoprire come destinare il tuo
//             5x1000 alle attività dell’associazione.
//           </p>
//         </div>
//       </section>

//       {/* --- NEWSLETTER --- */}
//       <section
//         id="newsletter"
//         className="relative z-10 w-11/12 md:w-3/4 lg:w-2/3 mb-16 bg-amber-100/70 border border-amber-200 rounded-3xl px-6 py-10 md:px-12 text-center"
//       >
//         <h2 className="text-2xl md:text-3xl font-bold text-red-600">
//           Iscriviti alla newsletter
//         </h2>
//         <p className="mt-3 text-gray-700 max-w-xl mx-auto">
//           Rimani aggiornato su corsi, eventi e iniziative.
//         </p>
//         <p className="mt-2 inline-flex items-center gap-2 text-red-600 font-semibold">
//           <FaGift />
//           Iscrivendoti oggi riceverai anche un piccolo gadget omaggio!
//         </p>

//         {state.succeeded ? (
//           <p className="mt-6 text-green-700 text-lg font-semibold">
//             ✅ Grazie per aver inviato la tua iscrizione! Ti contatteremo
//             presto.
//             <br />
//             🎁 E non dimenticare: un gadget omaggio ti aspetta!
//           </p>
//         ) : (
//           <form
//             onSubmit={handleSubmit}
//             className="mt-6 flex flex-col sm:flex-row gap-3 max-w-xl mx-auto"
//           >
//             <input type="hidden" name="_subject" value="Milarte Newsletter" />
//             <label htmlFor="newsletter-email" className="sr-only">
//               Email
//             </label>
//             <input
//               id="newsletter-email"
//               name="Email"
//               type="email"
//               required
//               placeholder="Inserisci la tua email"
//               className="flex-1 p-3 border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-red-400"
//             />
//             <button
//               type="submit"
//               disabled={state.submitting}
//               className="bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700 transition disabled:opacity-50 font-semibold"
//             >
//               Iscriviti
//             </button>
//           </form>
//         )}
//       </section>

//       {/* --- IMMAGINE A SCHERMO INTERO --- */}
//       {fullScreenImage && (
//         <div
//           className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4"
//           onClick={closeImage}
//           role="dialog"
//           aria-modal="true"
//         >
//           <img
//             src={fullScreenImage}
//             alt="Immagine ingrandita"
//             className="max-w-[90vw] max-h-[90vh] rounded-2xl shadow-2xl"
//           />
//         </div>
//       )}
//     </div>
//   );
// };

// export default Home;

import React, { useState, useEffect, useCallback } from "react";

import NuovaOrchestra from "../imgs/Nuova orchestra.jpeg";

import {
  FaUsers,
  FaBullseye,
  FaLightbulb,
  FaMusic,
  FaChevronLeft,
  FaChevronRight,
  FaSearchPlus,
  FaGift,
} from "react-icons/fa";

import { useForm } from "@formspree/react";
import loc5x1000 from "../imgs/Locandine/Locandina5x1000.jpeg";

/* ------------------------------------------------------------------ */
/* Import immagini galleria                                            */
/* ------------------------------------------------------------------ */

const importAll = (r) => r.keys().map(r);

const galleryImages = importAll(
  require.context(
    "../imgs/Galleria",
    false,
    /\.(png|jpe?g|webp)$/
  )
);

/* ------------------------------------------------------------------ */
/* Shuffle                                                             */
/* ------------------------------------------------------------------ */

const shuffle = (list) => {
  const copy = [...list];

  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }

  return copy;
};

/* ------------------------------------------------------------------ */
/* Gallery                                                             */
/* ------------------------------------------------------------------ */

const Gallery = ({ images, onOpen }) => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  const total = images.length;

  /* -------------------------------------------------------------- */
  /* Cambio automatico immagine                                     */
  /* -------------------------------------------------------------- */

  useEffect(() => {
    if (paused || total <= 1) return;

    const id = setInterval(() => {
      setIndex((current) => (current + 1) % total);
    }, 5000);

    return () => clearInterval(id);
  }, [paused, total]);

  /* -------------------------------------------------------------- */
  /* Navigazione                                                     */
  /* -------------------------------------------------------------- */

  const prev = useCallback(() => {
    setIndex((current) => (current - 1 + total) % total);
  }, [total]);

  const next = useCallback(() => {
    setIndex((current) => (current + 1) % total);
  }, [total]);

  if (total === 0) return null;

  return (
    <div
      className="
        relative
        w-11/12
        md:w-3/4
        lg:w-2/3
        h-80
        md:h-[28rem]
        rounded-3xl
        overflow-hidden
        shadow-xl
        bg-amber-100
      "
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      {images.map((src, i) => {
        const distance = (i - index + total) % total;

        /*
         * Manteniamo nel DOM solo:
         * - immagine corrente
         * - immagine precedente
         * - immagine successiva
         */
        if (distance > 1 && distance !== total - 1) {
          return null;
        }

        const active = i === index;

        return (
          <div
            key={src}
            className={`
              absolute
              inset-0
              transition-opacity
              duration-1000
              motion-reduce:transition-none
              ${
                active
                  ? "opacity-100"
                  : "opacity-0 pointer-events-none"
              }
            `}
          >
            {/* Sfondo sfocato */}
            <img
              src={src}
              alt=""
              aria-hidden="true"
              className="
                absolute
                inset-0
                w-full
                h-full
                object-cover
                scale-110
                blur-2xl
                opacity-60
              "
            />

            {/* Immagine principale */}
            <img
              src={src}
              alt={
                active
                  ? "Foto dalla galleria di MilArte"
                  : ""
              }
              aria-hidden={!active}
              onClick={() => active && onOpen(src)}
              className="
                relative
                w-full
                h-full
                object-contain
                cursor-zoom-in
              "
            />
          </div>
        );
      })}

      {total > 1 && (
        <>
          {/* Freccia precedente */}
          <button
            type="button"
            onClick={prev}
            aria-label="Foto precedente"
            className="
              absolute
              left-3
              top-1/2
              -translate-y-1/2
              z-10
              flex
              items-center
              justify-center
              w-10
              h-10
              rounded-full
              bg-black/50
              text-white
              hover:bg-red-600
              transition-colors
              focus:outline-none
              focus-visible:ring-4
              focus-visible:ring-red-400
            "
          >
            <FaChevronLeft />
          </button>

          {/* Freccia successiva */}
          <button
            type="button"
            onClick={next}
            aria-label="Foto successiva"
            className="
              absolute
              right-3
              top-1/2
              -translate-y-1/2
              z-10
              flex
              items-center
              justify-center
              w-10
              h-10
              rounded-full
              bg-black/50
              text-white
              hover:bg-red-600
              transition-colors
              focus:outline-none
              focus-visible:ring-4
              focus-visible:ring-red-400
            "
          >
            <FaChevronRight />
          </button>

          {/* Contatore */}
          <span
            className="
              absolute
              bottom-3
              right-3
              z-10
              bg-black/60
              text-white
              text-xs
              font-semibold
              px-3
              py-1
              rounded-full
            "
          >
            {index + 1} / {total}
          </span>
        </>
      )}
    </div>
  );
};

/* ------------------------------------------------------------------ */
/* Contenuti Chi siamo                                                */
/* ------------------------------------------------------------------ */

const chiSiamo = [
  {
    icon: <FaUsers />,
    color: "text-red-600 bg-red-50",
    titolo: "Chi siamo",
    testo: (
      <>
        MilArte è un'Associazione di Promozione Sociale dedicata alla musica,
        fondata nel 2023 con l'obiettivo di diffondere la passione musicale e
        creare un impatto positivo nella comunità. La visione di{" "}
        <a
          href="https://www.giuseppedinardo.it/"
          className="text-red-600 font-semibold hover:underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          Giuseppe Dinardo
        </a>{" "}
        ha guidato la nascita dell’associazione, consolidando la sua presenza
        nel panorama musicale milanese.
      </>
    ),
  },
  {
    icon: <FaBullseye />,
    color: "text-amber-700 bg-amber-100",
    titolo: "I nostri obiettivi",
    testo: (
      <>
        Gli obiettivi principali includono la proposta di concerti, eventi e
        iniziative culturali per rendere la musica accessibile e viva. MilArte
        lavora per creare esperienze musicali che arricchiscano la vita di chi
        ascolta e di chi suona.
      </>
    ),
  },
  {
    icon: <FaLightbulb />,
    color: "text-yellow-600 bg-yellow-50",
    titolo: "Nelle scuole",
    testo: (
      <>
        In programma anche visite e concerti nelle scuole per condividere la
        magia della musica fatta con mani umane e nutrire interiormente i
        giovani ascoltatori.
      </>
    ),
  },
];

/* ------------------------------------------------------------------ */
/* Home                                                               */
/* ------------------------------------------------------------------ */

const Home = () => {
  const [images] = useState(() => shuffle(galleryImages));

  const [fullScreenImage, setFullScreenImage] = useState(null);

  const [state, handleSubmit] = useForm("xpwkaddj");

  /* -------------------------------------------------------------- */
  /* Fullscreen                                                       */
  /* -------------------------------------------------------------- */

  const handleImageClick = (img) => {
    setFullScreenImage(img);
  };

  const closeImage = () => {
    setFullScreenImage(null);
  };

  /* -------------------------------------------------------------- */
  /* ESC per chiudere fullscreen                                     */
  /* -------------------------------------------------------------- */

  useEffect(() => {
    if (!fullScreenImage) return;

    const onKey = (event) => {
      if (event.key === "Escape") {
        setFullScreenImage(null);
      }
    };

    document.addEventListener("keydown", onKey);

    return () => {
      document.removeEventListener("keydown", onKey);
    };
  }, [fullScreenImage]);

  /* -------------------------------------------------------------- */
  /* Navigazione verso Chi siamo                                    */
  /* -------------------------------------------------------------- */

  const scrollToChiSiamo = (event) => {
    event.preventDefault();

    const section = document.getElementById("chi-siamo");

    if (!section) return;

    section.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <div
      className="
        flex
        flex-col
        items-center
        bg-gradient-to-r
        from-white
        to-amber-50
        min-h-screen
        text-gray-800
        overflow-hidden
      "
    >
      {/* Decorazione musicale */}
      <FaMusic
        className="
          fixed
          text-amber-200/40
          text-[180px]
          rotate-12
          -top-5
          -right-5
          z-0
          pointer-events-none
        "
      />

      {/* ---------------------------------------------------------- */}
      {/* INTESTAZIONE                                                */}
      {/* ---------------------------------------------------------- */}

      <header
        className="
          relative
          z-10
          flex
          flex-col
          md:flex-row
          items-center
          justify-center
          gap-6
          md:gap-10
          w-11/12
          md:w-3/4
          lg:w-2/3
          mt-10
          mb-8
          text-center
          md:text-left
        "
      >
        <img
          src={NuovaOrchestra}
          alt="Logo Nuova Orchestra"
          className="w-28 md:w-36 rounded-2xl shadow-lg"
        />

        <div>
          <h1
            className="
              text-red-600
              font-extrabold
              text-5xl
              md:text-6xl
              tracking-wide
            "
          >
            MilArte
          </h1>

          <p
            className="
              mt-2
              text-xl
              md:text-2xl
              text-amber-900
              font-medium
            "
          >
            Il bello di far musica insieme!
          </p>

          <div
            className="
              mt-5
              flex
              flex-wrap
              justify-center
              md:justify-start
              gap-3
            "
          >
            <a
              href="#chi-siamo"
              onClick={scrollToChiSiamo}
              className="
                bg-red-600
                text-white
                px-5
                py-2
                rounded-lg
                font-semibold
                text-base
                hover:bg-red-700
                transition
              "
            >
              Scopri chi siamo
            </a>

            <a
              href="#newsletter"
              className="
                border-2
                border-red-600
                text-red-600
                px-5
                py-2
                rounded-lg
                font-semibold
                text-base
                hover:bg-red-50
                transition
              "
            >
              Iscriviti alla newsletter
            </a>
          </div>
        </div>
      </header>

      {/* ---------------------------------------------------------- */}
      {/* GALLERIA                                                    */}
      {/* ---------------------------------------------------------- */}

      <div
        className="
          relative
          z-10
          w-full
          flex
          justify-center
          mb-16
        "
      >
        <Gallery
          images={images}
          onOpen={handleImageClick}
        />
      </div>

      {/* ---------------------------------------------------------- */}
      {/* CHI SIAMO                                                   */}
      {/* ---------------------------------------------------------- */}

      <section
        id="chi-siamo"
        className="
          relative
          z-10
          w-11/12
          md:w-3/4
          lg:w-2/3
          mb-16
        "
      >
        <h2
          className="
            text-3xl
            font-bold
            text-red-600
            mb-8
            text-center
            md:text-left
          "
        >
          Una associazione che fa musica insieme
        </h2>

        <div className="flex flex-col gap-8">
          {chiSiamo.map((voce) => (
            <div
              key={voce.titolo}
              className="flex items-start gap-5"
            >
              <span
                className={`
                  shrink-0
                  flex
                  items-center
                  justify-center
                  w-14
                  h-14
                  rounded-full
                  text-2xl
                  ${voce.color}
                `}
              >
                {voce.icon}
              </span>

              <div>
                <h3
                  className="
                    text-xl
                    font-semibold
                    text-gray-900
                  "
                >
                  {voce.titolo}
                </h3>

                <p
                  className="
                    mt-1
                    text-lg
                    leading-relaxed
                    text-gray-700
                  "
                >
                  {voce.testo}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ---------------------------------------------------------- */}
      {/* CITAZIONE                                                   */}
      {/* ---------------------------------------------------------- */}

      <section
        className="
          relative
          z-10
          w-full
          bg-red-700
          text-white
          py-16
          px-6
          mb-16
        "
      >
        <figure className="max-w-3xl mx-auto text-center">
          <h2
            className="
              text-xl
              md:text-2xl
              font-bold
              text-amber-200
              mb-6
            "
          >
            Nuova Milano
          </h2>

          <blockquote
            className="
              font-serif
              italic
              text-xl
              md:text-3xl
              leading-relaxed
            "
          >
            “Una scatola sono di cerini, i musicisti mentre stanno insieme,
            pronti a incendiarsi per spiccare il volo. Saranno un palloncino
            della fiera come quelli sfuggiti dalle mani che sembrano uno stormo
            cittadino o un labirinto in note musicali che anche a una carriola
            dà le ali.”
          </blockquote>

          <figcaption
            className="
              mt-6
              text-base
              md:text-lg
              font-semibold
              text-amber-100
            "
          >
            Guido Oldani, ideatore del Realismo Terminale (inedito)
          </figcaption>
        </figure>
      </section>

      {/* ---------------------------------------------------------- */}
      {/* 5x1000                                                       */}
      {/* ---------------------------------------------------------- */}

      <section
        className="
          relative
          z-10
          w-11/12
          md:w-3/4
          lg:w-2/3
          mb-16
          flex
          flex-col
          md:flex-row
          items-center
          gap-8
          bg-white/60
          backdrop-blur-md
          rounded-3xl
          shadow-md
          border
          border-amber-100
          p-6
          md:p-10
        "
      >
        <button
          type="button"
          onClick={() => handleImageClick(loc5x1000)}
          aria-label="Ingrandisci la locandina del 5x1000"
          className="
            relative
            w-2/3
            sm:w-1/2
            md:w-2/5
            shrink-0
            rounded-2xl
            overflow-hidden
            shadow-lg
            cursor-pointer
            group
            focus:outline-none
            focus-visible:ring-4
            focus-visible:ring-red-400
          "
        >
          <img
            src={loc5x1000}
            alt="Locandina 5x1000"
            className="
              w-full
              group-hover:scale-105
              transition-transform
              duration-700
            "
          />

          <span
            className="
              absolute
              bottom-3
              right-3
              flex
              items-center
              justify-center
              w-10
              h-10
              rounded-full
              bg-black/70
              text-white
              text-sm
              group-hover:bg-red-600
              transition-colors
              duration-300
            "
          >
            <FaSearchPlus />
          </span>
        </button>

        <div className="text-center md:text-left">
          <h2
            className="
              text-2xl
              md:text-3xl
              font-bold
              text-red-600
            "
          >
            Sostieni MilArte
          </h2>

          <p
            className="
              mt-3
              text-lg
              text-gray-700
              leading-relaxed
            "
          >
            Tocca la locandina per ingrandirla e scoprire come destinare il tuo
            5x1000 alle attività dell’associazione.
          </p>
        </div>
      </section>

      {/* ---------------------------------------------------------- */}
      {/* NEWSLETTER                                                  */}
      {/* ---------------------------------------------------------- */}

      <section
        id="newsletter"
        className="
          relative
          z-10
          w-11/12
          md:w-3/4
          lg:w-2/3
          mb-16
          bg-amber-100/70
          border
          border-amber-200
          rounded-3xl
          px-6
          py-10
          md:px-12
          text-center
        "
      >
        <h2
          className="
            text-2xl
            md:text-3xl
            font-bold
            text-red-600
          "
        >
          Iscriviti alla newsletter
        </h2>

        <p className="mt-3 text-gray-700 max-w-xl mx-auto">
          Rimani aggiornato su corsi, eventi e iniziative.
        </p>

        <p
          className="
            mt-2
            inline-flex
            items-center
            gap-2
            text-red-600
            font-semibold
          "
        >
          <FaGift />

          Iscrivendoti oggi riceverai anche un piccolo gadget omaggio!
        </p>

        {state.succeeded ? (
          <p
            className="
              mt-6
              text-green-700
              text-lg
              font-semibold
            "
          >
            ✅ Grazie per aver inviato la tua iscrizione! Ti contatteremo
            presto.
            <br />
            🎁 E non dimenticare: un gadget omaggio ti aspetta!
          </p>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="
              mt-6
              flex
              flex-col
              sm:flex-row
              gap-3
              max-w-xl
              mx-auto
            "
          >
            <input
              type="hidden"
              name="_subject"
              value="Milarte Newsletter"
            />

            <label
              htmlFor="newsletter-email"
              className="sr-only"
            >
              Email
            </label>

            <input
              id="newsletter-email"
              name="Email"
              type="email"
              required
              placeholder="Inserisci la tua email"
              className="
                flex-1
                p-3
                border
                border-gray-300
                rounded-lg
                bg-white
                focus:outline-none
                focus:ring-2
                focus:ring-red-400
              "
            />

            <button
              type="submit"
              disabled={state.submitting}
              className="
                bg-red-600
                text-white
                px-6
                py-3
                rounded-lg
                hover:bg-red-700
                transition
                disabled:opacity-50
                font-semibold
              "
            >
              {state.submitting ? "Invio..." : "Iscriviti"}
            </button>
          </form>
        )}
      </section>

      {/* ---------------------------------------------------------- */}
      {/* IMMAGINE A SCHERMO INTERO                                   */}
      {/* ---------------------------------------------------------- */}

      {fullScreenImage && (
        <div
          className="
            fixed
            inset-0
            bg-black/80
            flex
            items-center
            justify-center
            z-50
            p-4
          "
          onClick={closeImage}
          role="dialog"
          aria-modal="true"
          aria-label="Immagine ingrandita"
        >
          <img
            src={fullScreenImage}
            alt="Immagine ingrandita"
            className="
              max-w-[90vw]
              max-h-[90vh]
              rounded-2xl
              shadow-2xl
            "
            onClick={(event) => event.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default Home;

